var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FormGroup',[_c('FormInput',{ref:"text_default",attrs:{"type":"text","placeholder":_vm.$t('fieldTextSubForm.placeholder')},model:{value:(_vm.values.text_default),callback:function ($$v) {_vm.$set(_vm.values, "text_default", $$v)},expression:"values.text_default"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }